export const SLICE_NAME = 'departments';
